import { render, staticRenderFns } from "./QuadratureBam.vue?vue&type=template&id=630267a4&"
import script from "./QuadratureBam.vue?vue&type=script&lang=js&"
export * from "./QuadratureBam.vue?vue&type=script&lang=js&"
import style0 from "./QuadratureBam.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports